import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { trackEvent } from "@/utils/analytics";

const EASE = [0.16, 1, 0.3, 1];

export const CtaBand = () => (
  <section className="py-16 md:py-20 bg-white border-y border-hairline" data-testid="cta-band">
    <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
      >
        <h2 className="font-medium tracking-tight leading-tight text-2xl md:text-3xl text-ink" data-testid="cta-band-title">
          Run your first conversion free.
        </h2>
        <p className="text-sm text-fog leading-relaxed mt-3 max-w-md">
          No signup, no card — drop a file into the live tool at the top of this page and watch it work.
          Pick a plan only when your deal flow demands it.
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
        className="flex flex-wrap items-center gap-4 shrink-0"
      >
        <a href="#top" data-testid="cta-band-try" onClick={() => trackEvent("cta_click", { source: "cta_band_try" })}
          className="group inline-flex items-center gap-2 v4-btn-primary h-12 px-7 text-sm font-semibold transition-colors duration-200">
          Try the live tool <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-200" strokeWidth={1.5} />
        </a>
        <a href="#pricing" data-testid="cta-band-pricing" onClick={() => trackEvent("cta_click", { source: "cta_band_pricing" })}
          className="inline-flex items-center gap-2 border border-edge rounded-full text-ink h-12 px-7 text-sm font-medium hover:border-ink transition-colors duration-200">
          See pricing
        </a>
      </motion.div>
    </div>
  </section>
);
